import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class TeleInterconsultService extends BaseService() {
    static get entity() {
        return "tele_interconsult";
    }
    static get responseName() {
        return "tele_interconsult";
    }
    /**
     * Obtiene las teleinterconsultas según el usuario logeado, el estado y el establecimiento.
     * @param {string} state
     * @param {number} nodeId
     */
    static getByStateAndUser(state, nodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_state_user_id/${state}/${nodeId}`,
            });
        });
    }
    /**
     * Obtiene las teleinterconsultas según el estado y el node_destination_id.
     * @param {string} state
     * @param {number} nodeId
     */
    static getByStateAndDestination(state, nodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_state_node_destination_id/${state}/${nodeId}`,
            });
        });
    }
    /**
     * Obtiene las teleinterconsultas según el estado y el user_id del movimiento, además del destination_node_id de la teleinterconsulta.
     *
     * @param {Number} stablishmentId
     * @param {string} state
     * @param {Number} destinationNodeId
     */
    static getByStablishmentStateDestinationNode(stablishmentId, state, destinationNodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_state_node_destination_id/${stablishmentId}/${state}/${destinationNodeId}`,
            });
        });
    }
    /**
     * Obtiene las teleinterconsultas según el estado y el user_id del movimiento, además del origin_node_id de la teleinterconsulta.
     *
     * @param {Number} stablishmentId
     * @param {string} state
     * @param {Number} originNodeId
     */
    static getByStablishmentStateOriginNode(stablishment, state, originNodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_state_node_origin_id/${stablishment}/${state}/${originNodeId}`,
            });
        });
    }
    /**
     * Obtiene las teleinterconsultas según el estado y el user_id del movimiento, además del origin_node_id de la teleinterconsulta.
     *
     * @param {Number} id
     */
    static getFindByNodeOriginId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_node_origin_id/${id}`,
            });
        });
    }
    static getFindByNodeOriginIdNotClosed(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_node_origin_id_and_state/${id}`,
            });
        });
    }
    static getFindByNodeOriginIdClosed(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_node_origin_id_and_state_close/${id}`,
            });
        });
    }
    static getByStateAndNodeDestination(state, nodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_user_state_origin/${state}/${nodeId}`,
            });
        });
    }
    static getFindByUserStepOrigin(step, node_id, state) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_user_step_origin/${step}/${node_id}/${state}`,
            });
        });
    }
    /**
     * filtra las interconsultas asociadas a un establecimiento, dependiendo de que estado tenga y de en que paso se encuentre
     *
     * @param {string} step
     * @param {number} node_id
     * @param {string} state
     */
    static getFindByUserStepDestination(step, node_id, state) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_user_step_destination/${step}/${node_id}/${state}`,
            });
        });
    }
    /**
     * Obtiene las teleinterconsultas por step y state del tele_interconsult_state, y el node_origin_id de la tele_interconsult
     *
     * @param {string} step
     * @param {number} node_id
     * @param {string} state
     */
    static getTicByStateStepAndOriginNode(step, node_id, state) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_user_step_origin_nouser/${step}/${node_id}/${state}`,
            });
        });
    }
    /**
     * Obtiene las teleinterconsultas por step y state del tele_interconsult_state, y el node_destination_id de la tele_interconsult
     *
     * @param {string} step
     * @param {number} node_id
     * @param {string} state
     */
    static getTicByStateStepAndDestinationNode(step, node_id, state) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_user_state_destination_nouser/${step}/${node_id}/${state}`,
            });
        });
    }
    static getFindByPatientRut(rut) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_patient_rut/${rut}`,
            });
        });
    }
}
